import React from 'react';

import { DownloadOutlined } from '@ant-design/icons';
import { Button as AntdButton } from 'antd';

import { TableSort } from 'components/WrappedComponents/Table/types';
import { useExportDashboard } from 'hooks/dossiers/useExportDashboard';
import { useUserStore } from 'hooks/UserStoreContext';

import { FilterDashboardGardien } from '../Filters/types';

interface DownloadButtonProps<SortType extends string | undefined> {
  filters: Partial<FilterDashboardGardien>;
  sort: TableSort<SortType>;
}

function DownloadButton<SortType extends string | undefined>({
  filters,
  sort,
}: DownloadButtonProps<SortType>): React.ReactElement {
  const { exportDashboard, inProgress } = useExportDashboard();
  const user = useUserStore();

  return (
    <AntdButton
      icon={<DownloadOutlined />}
      type={'default'}
      shape={'round'}
      onClick={() => {
        exportDashboard(sort, {
          includeDossiersSortis: filters.includeDossiersSortis,
          classementList: filters.classement,
          dateRangeMiseAJour: filters.dateRangeMiseAJour,
          dateRangeMiseEnFourriere: filters.dateRangeMiseEnFourriere,
          idNatureBrancheList: filters.natureMiseEnFourriere,
          numeroRecherche: filters.search,
          idFourriereList: user.idCorrelationFourriere
            ? [user.idCorrelationFourriere]
            : undefined,
          statutDossierEnumList: filters.statut,
          actionsRequises: filters.actionsRequises,
          idMotifSortieList: filters.motifDeSortie,
          includeDossiersAnonymises: filters.includeDossiersAnonymises,
          marque: filters.idMarque,
          modele: filters.idModele,
          idJuridictionList: filters.idJuridictionList,
        });
      }}
      loading={inProgress}
    />
  );
}

export default DownloadButton;
